export const columnsDataCampaigns = [
  {
    Header: 'CÓDIGO',
    accessor: 'code',
  },
  {
    Header: 'DESCRIPCIÓN',
    accessor: 'description',
  },
  {
    Header: 'ACTIVA',
    accessor: 'active',
  },
  {
    Header: 'CHASIS',
    accessor: 'chassisInfo',
    enableSorting: false,
  },
  {
    Header: 'ACCIONES',
    accessor: 'actions',
  },
];
